import React from 'react';

interface FormStepperProps {
  steps: { label: string }[];
  currentStep: number;
  className?: string;
}

const ARROW_WIDTH = 14;
const STEP_HEIGHT = 44;
const HALF_HEIGHT = STEP_HEIGHT / 2;

const BORDER_COLOR = 'var(--color-cofee-greyBlue5)';
const BG_COLOR = 'var(--color-cofee-neutral1)';

const FormStepper = ({ steps, currentStep, className }: FormStepperProps) => (
  <div className={`flex ${className ?? ''}`}>
    {steps.map((step, index) => {
      const isFirst = index === 0;
      const isActiveOrCompleted = index <= currentStep;
      const textColorClass = isActiveOrCompleted
        ? 'text-cofeePrimary6'
        : 'text-cofeeNeutral6';

      return (
        <div
          key={step.label}
          className="flex flex-1 items-stretch"
          style={{ height: STEP_HEIGHT }}
        >
          <div
            className={`flex flex-1 items-center justify-center border-y border-cofeeGreyBlue5 text-sm font-medium ${textColorClass}
            ${isFirst ? 'border-l' : '-ml-4'}`}
          >
            {index + 1}. {step.label}
          </div>

          <svg
            width={ARROW_WIDTH}
            height={STEP_HEIGHT}
            viewBox={`0 0 ${ARROW_WIDTH} ${STEP_HEIGHT}`}
            className="shrink-0"
            fill="none"
          >
            <path
              d={`M0 0 L${ARROW_WIDTH} ${HALF_HEIGHT} L0 ${STEP_HEIGHT} Z`}
              fill={BG_COLOR}
            />
            <path
              d={`M0 0 L${ARROW_WIDTH} ${HALF_HEIGHT} L0 ${STEP_HEIGHT}`}
              stroke={BORDER_COLOR}
              strokeWidth="1"
            />
          </svg>
        </div>
      );
    })}
  </div>
);

export default FormStepper;
